import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqs = [
  {
    question: "What is MastaKash?",
    answer: "MastaKash is a digital financial platform that bridges informal community finance (chamas, table banking, merry-go-rounds) with formal banking infrastructure, empowering individuals and groups to save, invest, and borrow securely."
  },
  {
    question: "Does MastaKash replace mobile money services like M-Pesa?",
    answer: "No. MastaKash does not compete with mobile money providers. Instead, it provides digital infrastructure for managing community finance, integrating with mobile money and banking systems."
  },
  {
    question: "Who can use MastaKash?",
    answer: "Individuals, informal groups, chamas, and agents can all use MastaKash to save, borrow, lend, and transact securely."
  },
  {
    question: "How does MastaKash keep funds safe?",
    answer: "Group funds are stored in purpose-locked sub-wallets, ensuring that contributions for merry-gos, table banking, and other group activities cannot be misappropriated."
  },
  {
    question: "Can I use MastaKash across different mobile networks?",
    answer: "Yes. MastaKash allows money transfers and payments to any registered mobile number regardless of the network provider — no SIM juggling required."
  },
  {
    question: "What are the benefits of being a MastaKash agent?",
    answer: "Agents earn commissions by registering new customers, assisting with KYC, and providing banking services. They also gain access to business and financial literacy training."
  },
  {
    question: "Does MastaKash provide loans?",
    answer: "Yes. MastaKash offers digital loan tools including auto loan disbursements, custom loan products, and credit scoring to ensure fair and responsible lending."
  },
  {
    question: "How does MastaKash help groups grow financially?",
    answer: "Digital merry-gos, table banking, and fund drives allow groups to mobilize members across regions, build large saving pools, and access loans and credit efficiently."
  },
  {
    question: "Is MastaKash regulated?",
    answer: "MastaKash works closely with regulatory authorities and complies with financial regulations to ensure safe, auditable, and trusted operations."
  },
  {
    question: "How do I get started with MastaKash?",
    answer: "Sign up on the platform as an individual, group, or agent to start saving, lending, and transacting digitally and securely."
  },
];

const FAQsSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-purple-50 py-20" id="faqs">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-purple-900 mb-12">Frequently Asked Questions</h2>

        <div className="max-w-4xl mx-auto space-y-4 text-left">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl shadow hover:shadow-lg transition-shadow duration-300 p-6 cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center">
                <h3 className="text-purple-900 font-semibold text-lg">{faq.question}</h3>
                {openIndex === index ? <FaChevronUp className="text-orange-500" /> : <FaChevronDown className="text-orange-500" />}
              </div>
              {openIndex === index && (
                <p className="mt-4 text-purple-800">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQsSection;
